import React, { useState } from 'react'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { ResetPinDto } from 'src/services/types'
import { useDispatch } from 'react-redux'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { RiErrorWarningLine } from 'react-icons/ri'
import { Wrapper, FormContainer } from './style'
import PinInput from 'react-pin-input'
import { resetPinAction } from 'src/redux/actions/profileAction'
import { ModalTitleText, LabelText } from 'src/components/Global/Text/TitleText'
import useSnackbar from 'src/hooks/useSnackBar'

const ChangePIN = () => {
  const pinInputStyle = {
    padding: '16px',
    marginTop: '-20px',
  }

  const [userData, setUserData] = useState<ResetPinDto>({
    password: '',
    pin: '',
    pin_confirmation: '',
  })

  const dispatch = useDispatch()
  const { password, pin, pin_confirmation } = userData
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...userData }
    newData[name] = value
    setUserData(newData)
  }
  const payload = {
    PinSettings: {
      ...userData,
    },
  }
  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (
      !password ||
      !pin ||
      !pin_confirmation ||
      pin.length !== 6 ||
      pin !== pin_confirmation
    ) {
      setSubmitted(true)
      return
    }
    dispatch(resetPinAction({ payload, onSuccess, onError }))
    setLoading(true)
  }
  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: error,
      severity: 'error',
    })
  }
  const Disabled = () => {
    if (
      !password ||
      !pin ||
      !pin_confirmation ||
      pin.length !== 6 ||
      pin_confirmation.length !== 6 ||
      pin !== pin_confirmation
    ) {
      return 'blur'
    }
    return null
  }
  return (
    <FormContainer onSubmit={handleSubmit}>
      <Wrapper>
        <div>
          <ModalTitleText>Change Pin</ModalTitleText>
          <div className="amount">
            <LabelText>New pin</LabelText>
            <div
              className={'form-group' + (submitted && !pin ? ' has-error' : '')}
            >
              <PinInput
                length={6}
                initialValue=""
                secret
                type="numeric"
                onChange={(value, index) => {
                  userData['pin'] = value
                  setUserData(userData)
                }}
                inputMode="number"
                style={{ padding: '16px', marginTop: '-20px' }}
                inputStyle={{ borderColor: '#6E7191' }}
                inputFocusStyle={{ borderColor: '#0519ff' }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
              {(submitted && !pin && (
                <p className="error-text">Enter your new pin</p>
              )) ||
                (submitted && pin.length !== 6 && (
                  <p className="error-text">Pin must be 6 digits</p>
                ))}
            </div>
          </div>
          <div className="amount">
            <LabelText>Confirm pin</LabelText>
            <div
              className={
                'form-group' +
                (submitted && pin !== pin_confirmation ? ' has-error' : '')
              }
            >
              <PinInput
                length={6}
                initialValue=""
                secret
                type="numeric"
                inputMode="number"
                onChange={(value, index) => {
                  userData['pin_confirmation'] = value
                  setUserData(userData)
                }}
                style={{ padding: '16px', marginTop: '-20px' }}
                inputStyle={{ borderColor: '#6E7191' }}
                inputFocusStyle={{ borderColor: '#2336FF' }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
              {submitted && pin !== pin_confirmation && (
                <p className="error-text">Both Pins DO not match!</p>
              )}
            </div>
          </div>
          <div className="amount">
            <LabelText>Password</LabelText>
            <div
              className={
                'form-group' + (submitted && !password ? ' has-error' : '')
              }
            >
              <QuicksaveInput
                type="password"
                placeholder=""
                name="password"
                value={password}
                onChange={handleChange}
              />
              {submitted && !password && (
                <p className="error-text">Password is required</p>
              )}
              <RiErrorWarningLine className="error-icon" />
            </div>
          </div>
        </div>
        <div className="tops">
          <ModalButton>Update Pin {loading && <Spinner />}</ModalButton>
        </div>
      </Wrapper>
    </FormContainer>
  )
}
export { ChangePIN }
